import type { RoadState, SlotTrailState } from '@goodtime/shared';

/** A gift from the gift square waits on this road (or its game is open). */
export function giftWaiting(road: Pick<RoadState, 'gift' | 'giftGame'> | null): boolean {
  return !!road && ((!!road.gift && !road.gift.finished) || !!road.giftGame);
}

/**
 * The road's gift as the Sweet Trail's bonus, so its game opens through the
 * trail's own calls (useTrailGame, TrailBonusDialog): only `bonus`, `game`
 * and `level` matter there. The road's strip is drawn from the road itself.
 */
export function giftTrail(themeId: string, road: RoadState): SlotTrailState {
  return {
    themeId,
    collectorSymbolId: road.trail.collectorSymbolId,
    level: road.trail.level,
    position: road.trail.position,
    meter: road.trail.meter,
    stepCost: road.trail.cost,
    squares: [],
    collected: 0,
    steps: [],
    bonus: road.gift ?? null,
    game: road.giftGame ?? null,
  };
}
